'use client'

import { useTranslations } from 'next-intl'
import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styles from './VisaRenewal.module.css'

function FadeIn({ children, className }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref, { once: false, margin: '-80px' })
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}

export default function VisaRenewalBottom() {
  const t = useTranslations('VisaGuidePage.renewalTabs.visaRenewal')
  const WARNING_KEYS = ['1', '2', '3', '4'] as const
  const REMINDER_KEYS = ['1', '2', '3', '4'] as const

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        {/* Warnings */}
        <FadeIn className={styles.warningsSection}>
          <h3 className={styles.sectionSubtitle}>{t('warningsTitle')}</h3>
          <div className={styles.warningsList}>
            {WARNING_KEYS.map((k) => (
              <div key={k} className={styles.warningCard}>
                <div className={styles.warningError}>
                  <span className={styles.warningIcon}>!</span>
                  <p>{t(`warnings.${k}.error`)}</p>
                </div>
                <div className={styles.warningSolution}>
                  <span className={styles.solutionLabel}>→</span>
                  <p>{t(`warnings.${k}.solution`)}</p>
                </div>
              </div>
            ))}
          </div>
          <p className={styles.warningsContact}>
            {t('warningsContact')}{' '}
            <a href={`mailto:${t('warningsEmail')}`} className={styles.warningsEmail}>
              {t('warningsEmail')}
            </a>{' '}
            {t('warningsContactSuffix')}
          </p>
        </FadeIn>

        {/* Reminders */}
        <FadeIn className={styles.remindersSection}>
          <h3 className={styles.sectionSubtitle}>{t('warningsReminder')}</h3>
          <ul className={styles.remindersList}>
            {REMINDER_KEYS.map((k) => (
              <li key={k} className={styles.reminderItem}>
                <span className={styles.reminderDot} />
                <span>{t(`reminders.${k}`)}</span>
              </li>
            ))}
          </ul>
        </FadeIn>

      </div>
    </section>
  )
}